import React, { useState } from "react";
import "../styles/Navbar.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [analysisDropdownOpen, setAnalysisDropdownOpen] = useState(false);
    const [chartsDropdownOpen, setChartsDropdownOpen] = useState(false);
    const [surveillanceDropdownOpen, setSurveillanceDropdownOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const handleLinkClick = () => {
        setMenuOpen(false); // Close the menu when a link is clicked
        setAnalysisDropdownOpen(false); // Close analysis dropdown
        setChartsDropdownOpen(false); // Close charts dropdown
        setSurveillanceDropdownOpen(false); // Close surveillance dropdown
    };

        const handleWiseFluClick = (e) => {
        e.preventDefault();
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 10);
        } else {
            // If already on dashboard, just scroll to top
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        handleLinkClick();
    };

    const analysisOptions = [
        // Phylogenetic Analysis
        { id: 'subtree', label: 'Phylogenetic Subtree', category: 'phylogenetic' },
        { id: 'MRCAFinder', label: 'MRCA Finder', category: 'phylogenetic' },
        { id: 'hostComparison', label: 'Host Comparison', category: 'phylogenetic' },
    ];

        const surveillanceOptions = [
        { path: '/surveillance', label: 'Surveillance Dashboard', icon: '' },
        { path: '/mutation-analysis', label: 'Mutation Analysis', icon: '' },
        { path: '/laboratory-support', label: 'Laboratory Support', icon: '' },
        { path: '/batch-comparison', label: 'Batch Comparison', icon: '' },
        { path: '/pandemic-risk', label: 'Pandemic Risk Assessment', icon: '' },  // <-- ADD THIS LINE
    ];

    const chartOptions = [
        { id: 'phylogenetic', label: 'Phylogenetic Tree', hash: '#phylogenetic' },
        { id: 'cumulative', label: 'Cumulative Isolates', hash: '#cumulative' },
        { id: 'sequence', label: 'Sequence Collection', hash: '#sequence' },
        { id: 'map', label: 'Isolates Heat Map', hash: '#map' },
    ];

    const phylogeneticOptions = analysisOptions.filter(opt => opt.category === 'phylogenetic');

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Left Side: Title & Links */}
                <div className="navbar-left">
                    <NavLink to="/" className="navbar-title-link" onClick={handleWiseFluClick}>
                        <h1 className="navbar-title">WiseFlu</h1>
                    </NavLink>
                    <div className="vertical-separator"></div>

                    {/* Hamburger Menu */}
                    <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

                {/* Collapsible Menu */}
                <ul className={`nav-links ${menuOpen ? "show" : ""}`}>
                    <li 
                        className="dropdown-container"
                        onMouseEnter={() => setChartsDropdownOpen(true)}
                        onMouseLeave={() => setChartsDropdownOpen(false)}
                    >
                        <div 
                            className="nav-link dropdown-trigger"
                            onClick={() => setChartsDropdownOpen(!chartsDropdownOpen)}
                        >
                            Interactive Charts
                            <span className={`dropdown-arrow ${chartsDropdownOpen ? 'open' : ''}`}>▼</span>
                        </div>
                        <div className={`dropdown-menu ${chartsDropdownOpen ? 'show' : ''}`}>
                            <div className="dropdown-section">
                                {chartOptions.map(option => (
                                    <a
                                        key={option.id}
                                        href={`/${option.hash}`}
                                        className="dropdown-link"
                                        onClick={handleLinkClick}
                                    >
                                        {option.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </li>

                    <li
                        className="dropdown-container"
                        onMouseEnter={() => setSurveillanceDropdownOpen(true)}
                        onMouseLeave={() => setSurveillanceDropdownOpen(false)}
                    >
                        <div
                            className="nav-link dropdown-trigger"
                            onClick={() => setSurveillanceDropdownOpen(!surveillanceDropdownOpen)}
                        >
                            Surveillance Analysis
                            <span className={`dropdown-arrow ${surveillanceDropdownOpen ? 'open' : ''}`}>▼</span>
                        </div>
                        <div className={`dropdown-menu ${surveillanceDropdownOpen ? 'show' : ''}`}>
                            <div className="dropdown-section">
                                {surveillanceOptions.map(option => (
                                    <NavLink
                                        key={option.path}
                                        to={option.path}
                                        className="dropdown-link"
                                        onClick={handleLinkClick}
                                    >
                                        <span className="dropdown-icon">{option.icon}</span>
                                        {option.label}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    </li>
                    
                    <li
                        className="dropdown-container"
                        onMouseEnter={() => setAnalysisDropdownOpen(true)}
                        onMouseLeave={() => setAnalysisDropdownOpen(false)}
                    >
                        <div
                            className="nav-link dropdown-trigger"
                            onClick={() => setAnalysisDropdownOpen(!analysisDropdownOpen)}
                        >
                            Phylogenetic Analysis
                            <span className={`dropdown-arrow ${analysisDropdownOpen ? 'open' : ''}`}>▼</span>
                        </div>
                        <div className={`dropdown-menu ${analysisDropdownOpen ? 'show' : ''}`}>
                            <div className="dropdown-section">
                                {phylogeneticOptions.map(option => (
                                    <a
                                        key={option.id}
                                        href={`/Analysis?tool=${option.id}`}
                                        className="dropdown-link"
                                        onClick={handleLinkClick}
                                    >
                                        {option.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </li>

                    <li>
                        <NavLink
                            to="/metadataTable"
                            className="nav-link"
                            activeClassName="active"
                            onClick={handleLinkClick}
                        >
                            Metadata
                        </NavLink>
                    </li>
                    
                    <li>
                        <NavLink
                            to="/About"
                            className="nav-link"
                            activeClassName="active"
                            onClick={handleLinkClick}
                        >
                            About
                        </NavLink>
                    </li>
                </ul>

                {/* Right Side: Logos (visible only on large screens) */}
                <div className="navbar-right">
                    <a
                        href="https://www.cs.usask.ca/research/research-labs/the-bioinformatics-lab.php"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/logo_lab.png`}
                            alt="USASK BINFO"
                            className="logo"
                        />
                    </a>
                    <div className="vertical-separator"></div>
                    <a
                        href="https://www.helmylab.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/logo_vido.png`}
                            alt="VIDO"
                            className="logo"
                        />
                    </a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;